import {addItemToCart} from '../http/cartAPI';
import {readGuestCart, clearGuestCart} from './guestCart';

/**
 * После установки JWT: переносит строки из гостевой корзины (localStorage) на сервер.
 * Гостевая корзина очищается после попытки слияния. Обратный перенос не выполняется.
 */
export async function mergeGuestCartOnLogin() {
    const lines = readGuestCart();
    if (!lines.length) {
        return;
    }

    for (const line of lines) {
        const itemId = line.itemId;
        if (itemId == null) {
            continue;
        }
        const maxStock = Number(line.count);
        const cap = Number.isFinite(maxStock) && maxStock > 0 ? maxStock : 9999;
        let qty = Math.min(Number(line.itemCount) || 0, cap);
        if (qty <= 0) {
            continue;
        }

        for (let i = 0; i < qty; i++) {
            try {
                await addItemToCart(itemId);
            } catch {
                break;
            }
        }
    }

    clearGuestCart();
}
